import React from 'react';
import { Box, constants } from '@match/react-component-library';
import { LeftNav } from 'modules/components';

const { SPACE } = constants;

interface LeftNavLayoutProps {
  activeCategoryId?: number | string;
  children: React.ReactNode;
}

function LeftNavLayout({ activeCategoryId, children }: LeftNavLayoutProps) {
  return (
    <React.Fragment>
      <LeftNav activeCategoryId={activeCategoryId} />
      <Box flex={3} display="flex">
        <Box
          display="flex"
          flexDirection="column"
          maxWidth={830}
          height="100%"
          paddingLeft={SPACE.XXXLARGE}
          width="100%"
        >
          {children}
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default LeftNavLayout;
